import { useMemo } from 'react';

const contactCountWindowSize = 1000 * 60 * 60 * 24 * 3; // 3 day in ms

export interface RelationshipsData {
  startCount: number;
  currentHighCount: number;
  incrementStartTime: number; // unix timestamp
}

export default function useGlobalContactCount(relationships: RelationshipsData) {
  return useMemo(() => {
    const deltaContacts = relationships.currentHighCount - relationships.startCount;

    const countNow = () => {
      const currentTime = Date.now();
      const deltaTime = currentTime - relationships.incrementStartTime;
      return Math.round(
        relationships.startCount + deltaContacts * (deltaTime / contactCountWindowSize),
      );
    };

    const currentCount = countNow();
    // will increment this in the closure
    let rollingCount = currentCount;

    const getCurrentContactCount = () => {
      const maxCountRightNow = countNow();
      const increment = Math.floor(Math.random() * (maxCountRightNow - rollingCount));
      rollingCount += Math.max(increment, 0);
      return rollingCount;
    };

    return {
      contactCount: currentCount,
      getCurrentContactCount,
    };
  }, []);
}
